export default __webpack_public_path__ + "static/megaballsleep-1bc7d44202726ad947fcfc6b790cdba9.png";